import { ValueParser } from "./value-parser";
import { DateHelper } from "../../helper/date-helper";

declare let ExcelJS: any;
declare let saveAs: any;
export abstract class ExportToExcel {
	public static customizeDataNumber = (options: { gridCell?: any, excelCell?: any }) => {
		if (options.gridCell.rowType !== "data" || options.excelCell.value == null || options.gridCell.column.dataType !== "number") {
			return;
		}
		if (!options.excelCell.numFmt && options.gridCell.column.format) {
			options.excelCell.numFmt = options.gridCell.column.format as string;
		}
	}

	public static customizeSummaryNumber = (options: { gridCell?: any, excelCell?: any }) => {
		if ((options.gridCell.rowType !== "totalFooter" && options.gridCell.rowType !== "groupFooter") || options.excelCell.value == null) {
			return;
		}

		let oldValue = options.excelCell.value;

		if (typeof oldValue !== "string") {
			return;
		}

		// If oldValue contains anything other than digits, commas, dots, or minus sign, return
		if (!/^[\d.,-]+$/.test(oldValue)) {
			return;
		}

		let cleanedValue = ValueParser.cleanFormattedValue(oldValue);

		// Convert to a number, ensuring valid numeric conversion
		let newValue = parseFloat(cleanedValue);
		// Check if the result is a valid number, if not, skip the step
		if (isNaN(newValue)) {
			return;
		}

		options.excelCell.value = newValue;

		// (Dynamic Solution) Count decimal places in the cleanedValue (after replacing comma with dot)
		let decimalIndex = cleanedValue.indexOf(".");
		let decimalPlaces = decimalIndex >= 0 ? cleanedValue.length - decimalIndex - 1 : 0;

		// Build the number format dynamically based on the number of decimal places
		let numFmt = "#,##0" + (decimalPlaces > 0 ? "." + "0".repeat(decimalPlaces) : "");

		let gridFormat = options?.gridCell?.column?.format;
		if (typeof gridFormat === "string") {
			numFmt = gridFormat;
		}

		// Set the format dynamically based on the decimal places
		options.excelCell.numFmt = numFmt;
	};

	public static async exportDataGridToExcelAsync(
		dataGridInstance: DevExpress.ui.dxDataGrid,
		selectedRowsOnly: boolean = true,
		fileName: string = null
	) {
		const workbook = new ExcelJS.Workbook();
		const worksheet = workbook.addWorksheet("Main sheet");

		await DevExpress.excelExporter.exportDataGrid({
			worksheet,
			component: dataGridInstance,
			selectedRowsOnly,
			customizeCell: (e) => {
				ExportToExcel.customizeDataNumber(e);
				ExportToExcel.customizeSummaryNumber(e);
			}
		});
		const buffer = await workbook.xlsx.writeBuffer();
		saveAs(new Blob([buffer], { type: "application/octet-stream" }), fileName ?? "DataGrid.xlsx");
	}
	public static exportDataGrid(e: any, type: string = null) {
		let defaultName = "DataGrid";
		const workbook = new ExcelJS.Workbook();
		const worksheet = workbook.addWorksheet("Main sheet");

		return DevExpress.excelExporter.exportDataGrid({
			worksheet,
			component: e.component,
			customizeCell: e => {
				ExportToExcel.customizeDataNumber(e);
				ExportToExcel.customizeSummaryNumber(e);
			}
		})
			.then(() => {
				return workbook.xlsx.writeBuffer();
			})
			.then((buffer: any) => {
				let oldFileName = e.fileName;

				// Hack to be compatible with old way of saving files
				let onFileSaveOption = e.component.option("onFileSaving");

				// prefer name set in onFileSaving over the metadata typename
				if (oldFileName === defaultName && typeof onFileSaveOption === "function") {
					let option: { fileName?: string } = {};
					onFileSaveOption(option);
					if (option.fileName != null) {
						e.fileName = option.fileName;
					}
				}

				if (type !== null) {
					const parts = type.split(".");
					if (parts.length > 1) {
						defaultName = parts[1].toLowerCase();
					} else {
						defaultName = type.toLowerCase();
					}
				}

				if (e?.format === "EXCEL" && e.fileName === "Export") {
					let dateString = DateHelper.fullDateToFilename(DateHelper.nowAsDateWithTime());
					e.fileName = `Export ${dateString}`;
					saveAs(new Blob([buffer], { type: "application/octet-stream" }), e.fileName + ".xlsx");
				} else {
					saveAs(new Blob([buffer], { type: "application/octet-stream" }), (e.fileName === null || e.fileName === "DataGrid" ? defaultName : e.fileName) + ".xlsx");
				}
				e.cancel = true;
			});
	}
}
